import {AbstractBaseListener} from "./abstract-base.listener";
import {BaseMessage} from "./base-message.interface";

export function OnMessage<T extends Record<string, any>>(messageType: string, filterFn?: (message: BaseMessage<T>) => boolean, sorting = -1): (target: AbstractBaseListener, propertyKey: string, descriptor: PropertyDescriptor) => void {

    return function (target: any, _propertyKey: string, descriptor: PropertyDescriptor): void {
        AbstractBaseListener.addListenerInfo<T>(target, {
            messageType,
            method: descriptor.value,
            filterFn,
            sorting,
            bufferTime: 250
        });
    };

}
